module.exports = __webpack_public_path__ + "static/img/3areaB_20.e563d39.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_20.png
// module id = 1163
// module chunks = 1